import React from 'react';
import { Link } from 'react-router-dom';
import ProjectItem from '../../../../components/ProjectItem/ProjectItem';
import ProjectItem1 from '../../../../components/ProjectItem/ProjectItem1';

const ProjectsArea = () => {
   return (
      <>
         <div className="tp-prjects-area pt-20 pb-120">
            <div className="container">
               <div className="row">
                  <div className="col-12">
                     <div className="tp-prjects-tab-menu mb-60">
                        <ul className="nav justify-content-center" id="myTab" role="tablist">
                           <li className="nav-item" role="presentation">
                              <button className="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#home" type="button" role="tab" aria-controls="home" aria-selected="true">All</button>
                           </li>
                           <li className="nav-item" role="presentation">
                              <button className="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile" type="button" role="tab" aria-controls="profile" aria-selected="false">North</button>
                           </li>
                           <li className="nav-item" role="presentation">
                              <button className="nav-link" id="contact-tab" data-bs-toggle="tab" data-bs-target="#contact" type="button" role="tab" aria-controls="contact" aria-selected="false">East</button>
                           </li>
                           <li className="nav-item" role="presentation">
                              <button className="nav-link" id="contact-tab1" data-bs-toggle="tab" data-bs-target="#contact1" type="button" role="tab" aria-controls="contact1" aria-selected="false">South</button>
                           </li>
                           <li className="nav-item" role="presentation">
                              <button className="nav-link" id="contact-tab2" data-bs-toggle="tab" data-bs-target="#contact2" type="button" role="tab" aria-controls="contact2" aria-selected="false">West</button>
                           </li>                           
                        </ul>
                     </div>
                  </div>
               </div>
               <div className="row pb-50">
                  <div className="col-12">
                     <div className="tp-prjects-tab-content">
                        <div className="tab-content" id="myTabContent">
                           <div className="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">

                              <div className="row">                                 

                                 <ProjectItem project_img_num="/north/Rishi Raj.png" project_subtitle="Rishi Raj"
                                    project_title="Cat eye Consultancy Services"></ProjectItem>

                                 <ProjectItem project_img_num="/north/Chetan Sharma.png" project_subtitle="Chetan Sharma"
                                    project_title="Krishna Solutions"></ProjectItem>

                                 <ProjectItem project_img_num="/north/Vikas Bakshi.png" project_subtitle="Vikash Bakshi"
                                    project_title="SBJ BPO Services Ltd"></ProjectItem>

                                 <ProjectItem project_img_num="/north/Deepak Verma.png" project_subtitle="Deepak Verma"
                                    project_title="Incredible Times"></ProjectItem>

                                 <ProjectItem project_img_num="/north/Gaurav Chaudhary.png" project_subtitle="Gaurav Chaudhary"
                                    project_title="Aadifidelis Solutions Pvt Ltd"></ProjectItem>

                                 <ProjectItem project_img_num="/north/MUKESH PANDEY.png" project_subtitle="Mukesh Pandey"
                                    project_title="Reliable Consulting Services"></ProjectItem>

                                 <ProjectItem project_img_num="/north/ADITYA KUMAR.png" project_subtitle="Aditya Kumar"
                                    project_title="Rupya Finmart"></ProjectItem>
                                 
                                 <ProjectItem project_img_num="/east/SAMAR JANA FINANCE SOLUTION.png" project_subtitle="Samar Jana"
                                    project_title="Finance Solution"></ProjectItem>

                                 <ProjectItem project_img_num="/east/RAJU JAISWAL  RR ASSOCIATE.png" project_subtitle="Raju Jaisal"
                                    project_title="R R Associates"></ProjectItem>

                                 <ProjectItem project_img_num="/east/ABDUL MATIN SP FINANCE.png" project_subtitle="Abdul Matin"
                                    project_title="SP Finance Solutions"></ProjectItem>

                                 <ProjectItem project_img_num="/east/MAHESH KUMAR.png" project_subtitle="Mahesh Kumar"
                                    project_title="Capital links"></ProjectItem>

                                 <ProjectItem project_img_num="/east/Chintan Khuntia-- CAS INFO.png" project_subtitle="Chintan Khuntia"
                                    project_title="Cas Info Services"></ProjectItem>

                                 <ProjectItem project_img_num="/east/Akhaya Kumar Mallick-- My Mudra Fincorp.png" project_subtitle="Akhaya Kumar Mallick"
                                    project_title="My Mudra Fincorp"></ProjectItem>

                                 <ProjectItem project_img_num="/south/chandrashekar kp.png" project_subtitle="Chandrashekhara K P"
                                    project_title="My Mudra Fincorp"></ProjectItem>

                                 <ProjectItem project_img_num="/south/Vijay SLV.png" project_subtitle="Vijay Kumar"
                                    project_title="My Mudra Fincorp"></ProjectItem>

                                 <ProjectItem project_img_num="/south/Rajendra reddy.png" project_subtitle="Rajendra Reddy"
                                    project_title="My Mudra Fincorp"></ProjectItem>

                                 <ProjectItem1 project_img_num="/south/Arjun_A_Kalyam.png" project_subtitle="Arjun A Kalyam"
                                    project_title="My Mudra Fincorp" linkk="https://www.youtube.com/watch?v=PN_UJeedF2c" vIds="PN_UJeedF2c"></ProjectItem1>

                                 <ProjectItem project_img_num="/south/vishwas.png" project_subtitle="Vishwas"
                                    project_title="My Mudra Fincorp"></ProjectItem>

                                 <ProjectItem project_img_num="/south/MEEDA AJAY.png" project_subtitle="Meeda Ajay"
                                    project_title="My Mudra Fincorp"></ProjectItem>

                                 <ProjectItem project_img_num="/south/DINESH KUMAR THATIKONDA.png" project_subtitle="Dinesh Kumar Thatikonda"
                                    project_title="My Mudra Fincorp"></ProjectItem>

                                 <ProjectItem project_img_num="/south/D  ELAVAZHAVAN (2).png" project_subtitle="Rupendar Mutta"
                                    project_title="My Mudra Fincorp"></ProjectItem>

                                 <ProjectItem project_img_num="/south/PUSHPARAJU K B_Mysore.png" project_subtitle="Pushparaju K B"
                                    project_title="My Mudra Fincorp"></ProjectItem>

                                 <ProjectItem project_img_num="/south/D  ELAVAZHAVAN.png" project_subtitle="D Elavazhavan"
                                    project_title="My Mudra Fincorp"></ProjectItem>

                                 <ProjectItem project_img_num="/south/V Malathy Thy 7 services.png" project_subtitle="V Malathy"
                                    project_title="My Mudra Fincorp"></ProjectItem>

                                 <ProjectItem project_img_num="/south/KAseem Bee.png" project_subtitle="Kaseem Bee"
                                    project_title="My Mudra Fincorp"></ProjectItem>

                                 <ProjectItem project_img_num="/south/K USHA_Vizag.png" project_subtitle="K Usha"
                                    project_title="My Mudra Fincorp"></ProjectItem>

                                 <ProjectItem project_img_num="/south/Kishore.png" project_subtitle="U Kishore"
                                    project_title="My Mudra Fincorp"></ProjectItem>


                                <ProjectItem project_img_num="/west/KIRAN KALSHETTI.png" project_subtitle="Kiran Kalshetti"
                                    project_title="KK Capital Company"></ProjectItem>

                                 <ProjectItem project_img_num="/west/Hiren Parmar.png" project_subtitle="Hiren K parmar"
                                    project_title="Hiren K Parmar"></ProjectItem>

                                 <ProjectItem project_img_num="/west/SARVANG DESAI.png" project_subtitle="Sarvang Desai"
                                    project_title="Fineoteric Consulting LLP"></ProjectItem>

                                 <ProjectItem project_img_num="/west/MADHAV KUTE.png" project_subtitle="Madhav Kute"
                                    project_title="Pdmstar India Private Limited"></ProjectItem>

                                 <ProjectItem project_img_num="/west/YASHWANTRAYA SIGARAKANTI.png" project_subtitle="Yashwantraya Sigarakanti"
                                    project_title="Mahalaxmi Financial Services"></ProjectItem>

                                 <ProjectItem project_img_num="/west/SANTOSH GAWANDE.png" project_subtitle="Santosh Gawande"
                                    project_title="Finance Mantrs Pvt Ltd"></ProjectItem>

                                 <ProjectItem project_img_num="/west/VIVEK ASHTANKAR.png" project_subtitle="Vivek Ashtankar"
                                    project_title="Sachchidanand Associate"></ProjectItem>

                                 <ProjectItem project_img_num="/west/MILIND CHOUDHARY.png" project_subtitle="Milind Choudhary"
                                    project_title="Raya Financial Services"></ProjectItem>

                                 <ProjectItem project_img_num="/west/Dhaval Shah.png" project_subtitle="Deval dhaval Shah"
                                    project_title="Deval Dhaval Shah"></ProjectItem>

                                 <ProjectItem project_img_num="/west/Ankita Patel.png" project_subtitle="Ankita Patel"
                                    project_title="Finwizz Financial Services Pvt Ltd"></ProjectItem>

                                 <ProjectItem project_img_num="/west/Rushin Shah.png" project_subtitle="Rushin Shah"
                                    project_title="Impetus Adcon Pvt Ltd"></ProjectItem>

                                 <ProjectItem project_img_num="/west/KARAN DODHIAWALA.png" project_subtitle="Karan Dodhiawala"
                                    project_title="Funding Millions"></ProjectItem>

                                 <ProjectItem project_img_num="/west/jayesh sonware.png" project_subtitle="Jayesh Sonwadiya"
                                    project_title="Shraddha Associate"></ProjectItem>
                              </div>
                           </div>

                           <div className="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                              <div className="row">                                 

                                  <ProjectItem project_img_num="/north/Rishi Raj.png" project_subtitle="Rishi Raj"
                                    project_title="Cat eye Consultancy Services"></ProjectItem>

                                 <ProjectItem project_img_num="/north/Chetan Sharma.png" project_subtitle="Chetan Sharma"
                                    project_title="Krishna Solutions"></ProjectItem>

                                 <ProjectItem project_img_num="/north/Vikas Bakshi.png" project_subtitle="Vikash Bakshi"
                                    project_title="SBJ BPO Services Ltd"></ProjectItem>

                                 <ProjectItem project_img_num="/north/Deepak Verma.png" project_subtitle="Deepak Verma"
                                    project_title="Incredible Times"></ProjectItem>

                                 <ProjectItem project_img_num="/north/Gaurav Chaudhary.png" project_subtitle="Gaurav Chaudhary"
                                    project_title="Aadifidelis Solutions Pvt Ltd"></ProjectItem>

                                 <ProjectItem project_img_num="/north/MUKESH PANDEY.png" project_subtitle="Mukesh Pandey"
                                    project_title="Reliable Consulting Services"></ProjectItem>

                                 <ProjectItem project_img_num="/north/ADITYA KUMAR.png" project_subtitle="Aditya Kumar"
                                    project_title="Rupya Finmart"></ProjectItem>

                              </div>
                           </div>

                           <div className="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">
                              <div className="row">

                                 <ProjectItem project_img_num="/east/SAMAR JANA FINANCE SOLUTION.png" project_subtitle="Samar Jana"
                                    project_title="Finance Solution"></ProjectItem>

                                 <ProjectItem project_img_num="/east/RAJU JAISWAL  RR ASSOCIATE.png" project_subtitle="Raju Jaisal"
                                    project_title="R R Associates"></ProjectItem>

                                 <ProjectItem project_img_num="/east/ABDUL MATIN SP FINANCE.png" project_subtitle="Abdul Matin"
                                    project_title="SP Finance Solutions"></ProjectItem>

                                 <ProjectItem project_img_num="/east/MAHESH KUMAR.png" project_subtitle="Mahesh Kumar"
                                    project_title="Capital links"></ProjectItem>

                                 <ProjectItem project_img_num="/east/Chintan Khuntia-- CAS INFO.png" project_subtitle="Chintan Khuntia"
                                    project_title="Cas Info Services"></ProjectItem>

                                 <ProjectItem project_img_num="/east/Akhaya Kumar Mallick-- My Mudra Fincorp.png" project_subtitle="Akhaya Kumar Mallick"
                                    project_title="My Mudra Fincorp"></ProjectItem>

                              </div>
                           </div>

                           <div className="tab-pane fade" id="contact1" role="tabpanel" aria-labelledby="contact-tab1">
                              <div className="row">

                                 <ProjectItem project_img_num="/south/chandrashekar kp.png" project_subtitle="Chandrashekhara K P"
                                    project_title="My Mudra Fincorp"></ProjectItem>

                                 <ProjectItem project_img_num="/south/Vijay SLV.png" project_subtitle="Vijay Kumar"
                                    project_title="My Mudra Fincorp"></ProjectItem>

                                 <ProjectItem project_img_num="/south/Rajendra reddy.png" project_subtitle="Rajendra Reddy"
                                    project_title="My Mudra Fincorp"></ProjectItem>

                                 <ProjectItem1 project_img_num="/south/Arjun_A_Kalyam.png" project_subtitle="Arjun A Kalyam"
                                    project_title="My Mudra Fincorp" linkk="https://www.youtube.com/watch?v=PN_UJeedF2c" vIds="PN_UJeedF2c"></ProjectItem1>

                                 <ProjectItem project_img_num="/south/vishwas.png" project_subtitle="Vishwas"
                                    project_title="My Mudra Fincorp"></ProjectItem>

                                 <ProjectItem project_img_num="/south/MEEDA AJAY.png" project_subtitle="Meeda Ajay"
                                    project_title="My Mudra Fincorp"></ProjectItem>

                                 <ProjectItem project_img_num="/south/DINESH KUMAR THATIKONDA.png" project_subtitle="Dinesh Kumar Thatikonda"
                                    project_title="My Mudra Fincorp"></ProjectItem>

                                 <ProjectItem project_img_num="/south/D  ELAVAZHAVAN (2).png" project_subtitle="Rupendar Mutta"
                                    project_title="My Mudra Fincorp"></ProjectItem>

                                 <ProjectItem project_img_num="/south/PUSHPARAJU K B_Mysore.png" project_subtitle="Pushparaju K B"
                                    project_title="My Mudra Fincorp"></ProjectItem>

                                 <ProjectItem project_img_num="/south/D  ELAVAZHAVAN.png" project_subtitle="D Elavazhavan"
                                    project_title="My Mudra Fincorp"></ProjectItem>

                                 <ProjectItem project_img_num="/south/V Malathy Thy 7 services.png" project_subtitle="V Malathy"
                                    project_title="My Mudra Fincorp"></ProjectItem>

                                 <ProjectItem project_img_num="/south/KAseem Bee.png" project_subtitle="Kaseem Bee"
                                    project_title="My Mudra Fincorp"></ProjectItem>

                                 <ProjectItem project_img_num="/south/K USHA_Vizag.png" project_subtitle="K Usha"
                                    project_title="My Mudra Fincorp"></ProjectItem>

                                 <ProjectItem project_img_num="/south/Kishore.png" project_subtitle="U Kishore"
                                    project_title="My Mudra Fincorp"></ProjectItem>

                              </div>
                           </div>

                           <div className="tab-pane fade" id="contact2" role="tabpanel" aria-labelledby="contact-tab2">
                              <div className="row">

                                 <ProjectItem project_img_num="/west/KIRAN KALSHETTI.png" project_subtitle="Kiran Kalshetti"
                                    project_title="KK Capital Company"></ProjectItem>

                                 <ProjectItem project_img_num="/west/Hiren Parmar.png" project_subtitle="Hiren K parmar"
                                    project_title="Hiren K Parmar"></ProjectItem>

                                 <ProjectItem project_img_num="/west/SARVANG DESAI.png" project_subtitle="Sarvang Desai"
                                    project_title="Fineoteric Consulting LLP"></ProjectItem>

                                 <ProjectItem project_img_num="/west/MADHAV KUTE.png" project_subtitle="Madhav Kute"
                                    project_title="Pdmstar India Private Limited"></ProjectItem>

                                 <ProjectItem project_img_num="/west/YASHWANTRAYA SIGARAKANTI.png" project_subtitle="Yashwantraya Sigarakanti"
                                    project_title="Mahalaxmi Financial Services"></ProjectItem>

                                 <ProjectItem project_img_num="/west/SANTOSH GAWANDE.png" project_subtitle="Santosh Gawande"
                                    project_title="Finance Mantrs Pvt Ltd"></ProjectItem>

                                 <ProjectItem project_img_num="/west/VIVEK ASHTANKAR.png" project_subtitle="Vivek Ashtankar"
                                    project_title="Sachchidanand Associate"></ProjectItem>

                                 <ProjectItem project_img_num="/west/MILIND CHOUDHARY.png" project_subtitle="Milind Choudhary"
                                    project_title="Raya Financial Services"></ProjectItem>

                                 <ProjectItem project_img_num="/west/Dhaval Shah.png" project_subtitle="Deval dhaval Shah"
                                    project_title="Deval Dhaval Shah"></ProjectItem>

                                 <ProjectItem project_img_num="/west/Ankita Patel.png" project_subtitle="Ankita Patel"
                                    project_title="Finwizz Financial Services Pvt Ltd"></ProjectItem>

                                 <ProjectItem project_img_num="/west/Rushin Shah.png" project_subtitle="Rushin Shah"
                                    project_title="Impetus Adcon Pvt Ltd"></ProjectItem>

                                 <ProjectItem project_img_num="/west/KARAN DODHIAWALA.png" project_subtitle="Karan Dodhiawala"
                                    project_title="Funding Millions"></ProjectItem>

                                 <ProjectItem project_img_num="/west/jayesh sonware.png" project_subtitle="Jayesh Sonwadiya"
                                    project_title="Shraddha Associate"></ProjectItem>

                              </div>
                           </div>                           

                        </div>
                     </div>
                  </div>
               </div>
               
               {/* <div className="row">
                  <div className="col-12">
                     <div className="tp-projects-btn d-flex justify-content-center">
                        <Link to="/projectsDetails" className="theme-btn text-white">
                           <i className="flaticon-enter"></i> Explore More</Link>
                     </div>
                  </div>
               </div> */}

            </div>
         </div>
      </>
   );
};

export default ProjectsArea;